import { IconName } from '@purpur/library/icon';
import { InputType } from 'storybook/internal/csf';

import { ICONS_SVG_PATH, ICONS_SVG_VERSION } from '@telialt/assets/src/constants';
import { LocalIconName } from '@telialt/utils/src/@types/LocalIconName';
import { localIconNameList } from '@telialt/utils/src/@types/localIconNameList';
import { purpurIconNameList } from '@telialt/utils/src/@types/purpurIconNameList';

const purpurIconNameSet = new Set<string>(purpurIconNameList);

export const isPurpurIconName = (type: string): type is IconName => purpurIconNameSet.has(type);

export const getLocalSvgIconString = (type: LocalIconName | string) => {
    const url = `${ICONS_SVG_PATH}?${ICONS_SVG_VERSION}#${type}`;

    return `
    <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="currentColor">
        <use xlink:href=${url} />
    </svg>
    `;
};

export const getLocalSvgIcon = (type: LocalIconName | string) => ({
    name: type,
    svg: getLocalSvgIconString(type),
});

export const storybookIconListControl: InputType = {
    control: { type: 'select' },
    options: purpurIconNameList.concat(localIconNameList),
    defaultValue: 'pebble' as IconName | LocalIconName,
    name: 'select icon',
};
